import type pino from 'pino';

/**
 * Creates a child logger with a specific context/module name.
 * All log entries produced by the child will include `{ context }`.
 *
 * @param logger  - The parent pino logger instance
 * @param context - A short label such as 'Timer', 'EmailService', 'WindowManager'
 * @returns A child logger with the context field
 */
export function createContextLogger(logger: pino.Logger, context: string): pino.Logger {
  return logger.child({ context });
}
